export default __webpack_public_path__ + "media/images/the_basics-4eef717445a2f4c59d0b339511c1cbf4.svg";